import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsxs as e } from "react/jsx-runtime";
import { Component as t, Children as r, cloneElement as a, createElement as o } from "react";
import { calculateRem as s, withVDSManager as i } from "@vds-core/utilities";
import { LayoutTokens as n } from "@vds-tokens/layout";
import d from "styled-components";
import l from "../utils/showError.js";
import p from "./RadioButton.js";
var c = s(n.space["6X"].value),
  u = s(n.space["5X"].value),
  h = d.div.withConfig({
    displayName: "RadioButtonGroupWrapper",
    componentId: "VDS__sc-t2oxs-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding-left: ", ";\n\n  > .radioWrapper {\n    margin-top: ", ";\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n"])), u, c);
var f = /*#__PURE__*/function (_t) {
  _inherits(f, _t);
  function f(e) {
    var _this;
    _classCallCheck(this, f);
    var t;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, e)), t = _assertThisInitialized(_assertThisInitialized(_this)), _this.canShowErrorState = function (e) {
      var r = t.props.data && t.props.data.map(function (e) {
        return e.value;
      }).indexOf(e);
      r && t.setState({
        enableErrorState: !!e && r < 0
      });
    }, _this._handleRadioSelect = function (e) {
      t.props.onChange && t.props.onChange(e), t.props.hasOwnProperty("value") || (t.setState({
        selectedRadio: e.target.value
      }), t.canShowErrorState(e.target.value)), l(e, t);
    }, _this.state = {
      selectedRadio: _this.props.defaultValue || _this.props.value,
      enableErrorState: !1,
      error: !0 === _this.props.error
    };
    return _this;
  }
  _createClass(f, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var e = this.props.defaultValue || this.props.value;
      this.canShowErrorState(e);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e) {
      e.value !== this.props.value && (this.setState({
        selectedRadio: this.props.value
      }), this.canShowErrorState(this.props.value)), e.error !== this.props.error && this.setState({
        error: !0 === this.props.error
      });
    }
  }, {
    key: "_renderRadios",
    value: function _renderRadios() {
      var e = this;
      var _this$props = this.props,
        t = _this$props.children,
        o = _this$props.error,
        s = _this$props.surface;
      return r.map(t, function (t, r) {
        var i = t;
        return a(i, {
          key: r + 1,
          checked: e.state.selectedRadio ? e.state.selectedRadio === i.props.value : 0 === r,
          selected: e.state.selectedRadio ? e.state.selectedRadio === i.props.value : 0 === r,
          onChange: e._handleRadioSelect,
          error: o,
          surface: s
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var t = this;
      var _this$props2 = this.props,
        r = _this$props2.children,
        a = _this$props2.data,
        s = _this$props2.error,
        i = _this$props2.id,
        n = _this$props2.ariaLabel,
        d = _this$props2.surface,
        l = this.state.error || "boolean" == typeof s && s;
      return e(h, {
        id: i,
        role: "radiogroup",
        "aria-label": n,
        children: [r && this._renderRadios(), a && a.map(function (e, r) {
          var a = e && e.inputId || null;
          return o(p, Object.assign({}, e, {
            id: e.id,
            inputId: a || void 0,
            key: r + 1,
            name: e.name,
            disabled: e.disabled,
            error: t.state.enableErrorState ? l : void 0,
            value: e.value,
            selected: t.state.selectedRadio ? t.state.selectedRadio === e.value.toString() : 0 === r,
            onChange: t._handleRadioSelect,
            tabIndex: t.state.selectedRadio || 0 === r ? 0 : -1,
            surface: d,
            label: e.label
          }), e.children);
        })]
      });
    }
  }]);
  return f;
}(t);
f.defaultProps = {
  defaultValue: "",
  error: !1,
  onChange: function onChange() {
    return {};
  },
  ariaLabel: "",
  surface: "light"
};
var m = i(f);
export { m as default };